import { type ReactNode } from 'react'
import { useWindowDimensions, View } from 'react-native'
import { usePathname } from 'expo-router'

import { isWeb } from '@/constants/app'
import { WEB_VIEW_MAX_WIDTH } from '@/constants/config'

function MaxWidthWrapper({ children }: { children: ReactNode }) {
  const { width } = useWindowDimensions()
  const pathname = usePathname()
  const isFullWidth = pathname === '/scan2pay-qr'
  const maxWidth = isFullWidth ? width : isWeb ? WEB_VIEW_MAX_WIDTH : width
  return (
    <View className={'flex-1 items-center'}>
      <View className={'w-full flex-1'} style={{ maxWidth }}>
        {children}
      </View>
    </View>
  )
}

export default MaxWidthWrapper
